export const SIGN_IN = "SIGN_IN";
export const ENC_DATA_SIGN_IN = "ENC_DATA_SIGN_IN";
export const GET_FACTORS = "GET_FACTORS";
export const GET_QUESTION_STATUS = "GET_QUESTION_STATUS";
export const SKIP_FACTORS = "SKIP_FACTORS";
export const VERIFY_FACTORS = "VERIFY_FACTORS";
export const RESEND_PASSCODE = "RESEND_PASSCODE";
export const AUTHORIZE = "AUTHORIZE";
export const CHECK_OKTA_SESSION = "CHECK_OKTA_SESSION";
export const AUTHORIZE_IN_OKTA = "AUTHORIZE_IN_OKTA";
export const DELETE_OKTA_SESSION = "DELETE_OKTA_SESSION";
export const CLEAN_UP = "CLEAN_UP";
export const CHECK_ENCDATA_TOKEN = "CHECK_ENCDATA_TOKEN";
export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";


